module.exports = __webpack_public_path__ + "static/media/title.41fdf212.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/projects/sensor-toolkit/title.jpg
// module id = 808
// module chunks = 0